import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSvgData = createAsyncThunk(
    'svgDetails/fetchSvgDetails',
    async (productId) => {
        const response = await fetch(`https://test2.svgheart.com/wp-json/svgheartwc/v1/product?product_id=${productId}`);
        const data = await response.json();
        return data;
    }
);

const svgSlice = createSlice({
    name: 'svg',
    initialState: {
        svgDetails: null,
        status: 'idle',
        error: null,
        isLoaded: false,
    },
    reducers: {
        setFabricCanvasAsImage: (state, action) => {
            if (state.svgDetails && state.svgDetails.data) {
                state.svgDetails.data.image = action.payload;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSvgData.pending, (state) => {
                state.status = 'loading';
                state.isLoaded = false;
            })
            .addCase(fetchSvgData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.svgDetails = action.payload;
                state.isLoaded = true;
            })
            .addCase(fetchSvgData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
                state.isLoaded = false;
            });
    },
});

export const { setFabricCanvasAsImage } = svgSlice.actions;
export default svgSlice.reducer;
